export default __webpack_public_path__ + "assets/images/28453ad696e1263c80ddb385a95ede9a.d7827486cf597ef313340308ad2930f1.jpg";